import Vue from 'vue'
const $t = Vue.prototype.$t

export const contentTemplate = [
  {
    key: $t('invite_42'),
    value: 'NAME'
  },
  {
    key: $t('invite_57'),
    value: 'ENNAME'
  },
  {
    key: $t('30'),
    value: 'REGULARDATE'
  },
  {
    key: $t('28'),
    value: 'EMPDATE'
  }
]

export const initData = {
  name: '', // 提醒名称
  notice_time: [{
    column: '', // 提醒时间：转正日期、入职日期
    type: '', // 提醒时间：之前、之后
    day: '' // 提醒时间： XX天
  }],
  formal_state: [], // 适用试用期状态：必填，多选
  notice_to: [], // 通知对象
  staff_ids: [], // 人员
  send: [], // 通知方式
  title: '', // 标题
  content: '' // 内容模板
}

export const ruleInitData = {
  name: [{ required: true, message: $t('1256'), trigger: 'blur' }], // 提醒名称
  formal_state: [{ required: true, message: $t('221'), trigger: 'blur' }], // 适用试用期状态：必填，多选
  notice_to: [{ required: true, message: $t('221'), trigger: 'blur' }], // 通知对象
  staff_ids: [{ required: true, message: $t('221'), trigger: 'blur' }], // 人员
  send: [{ required: true, message: $t('221'), trigger: 'blur' }], // 通知方式
  title: [{ required: true, message: $t('1256'), trigger: 'blur' }], // 标题
  content: [{ required: true, message: $t('1256'), trigger: 'blur' }] // 内容模板
}
